import request from '../services/request';

import Api from '@/api/api';

export const getEveryUserContent = (page, limit, orderBy = 'createdAt') => request.get('/content/list', {
  params: {
    page,
    limit,
    orderBy,
  },
});

export const getSubscribersOnlyUserContent = (
  page,
  limit,
  orderBy,
) => request.get('/content/dashboard/subscribers-only', { params: { page, limit, orderBy } });

export const getUserSocialsContent = (
  page,
  limit,
  orderBy,
) => request.get('/content/dashboard/socials', { params: { page, limit, orderBy } });

export const getUserExtrasContent = (
  page,
  limit,
  orderBy,
) => request.get('/content/dashboard/extras', { params: { page, limit, orderBy } });

export const getUserDraftContent = (
  page,
  limit,
  orderBy,
) => request.get('/content/dashboard/drafts', { params: { page, limit, orderBy } });

export const getUserPublishedContent = (
  page,
  limit,
  orderBy,
) => request.get('/content/dashboard/published', { params: { page, limit, orderBy } });

export const extras = {
  claims: {
    get: (contentId, page, limit) => request.get(
      `/content/${contentId}/claims`,
      { params: { contentId, page, limit } },
    ),
    getNumber: contentId => request.get(
      '/payments/transaction/content/get-number-of-customers',
      { params: { contentId } },
    ),
  },
};

export const getUserContentOfType = (uid, type, page, limit) => request.get('/posts', {
  params: {
    uid,
    type,
    page,
    limit,
  },
});

export const getUserNativeContent = (uid, page, limit) => request.get('/posts/native', {
  params: {
    uid,
    page,
    limit,
  },
});

export const getFeed = (uid, params) => request.get(`/posts/${uid}/feed`, { params });

export const getUserContentBySearchQuery = (uid, type, query, page, limit) => request.get('/posts/search', {
  params: {
    uid,
    type,
    query,
    page,
    limit,
  },
});

export const isContentClaimed = (
  userId,
  contentId,
) => request.get('payments/transaction/content/isClaimed', { params: { userId, contentId } });

export const getContentHits = filter => request.get('hit/content', { params: filter });

class ContentApi extends Api {
  constructor() {
    super('content');
  }

  findOneToEdit(id) {
    return this.get(`${id}/edit`);
  }

  getNew(id, purchaseToken) {
    const config = purchaseToken ? { params: { purchaseToken } } : {};
    return this.get(`${id}/new`, config);
  }

  findOneToEditNew(id) {
    return this.get(`${id}/edit-new`);
  }
}

export default new ContentApi();

export const createContent = type => request.post('content/create', { type });

export const updateContent = (id, payload) => request.put(`content/${id}/update`, payload);

export const createLesson = data => request.post('content/lesson', data);

export const createModule = data => request.post('content/module', data);

export const updateModule = data => request.put('content/module', data);

export const createPaymentIntent = id => request.post(`content/${id}/payment-intent`);

export const getTrybBlogFeed = () => request.get('blog');

export const claimContent = contentId => request.post(`content/${contentId}/claim`);
